import { MapPin } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

const MARKETS = [
    "Florida",
    "Texas",
    "Mississippi",
    "Southeastern United States",
    "Additional Sunbelt Markets",
];

export default function AboutMarkets() {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="bg-[#FAFAF9] py-24 lg:py-32"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
                <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-12 lg:gap-20">
                    <div className="lg:col-span-5">
                        <Reveal className="relative">
                            <div className="overflow-hidden rounded-[1.75rem] shadow-xl">
                                <img
                                    src="/images/renovation.jpg"
                                    alt="Freshly renovated value-add apartment kitchen"
                                    className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
                                />
                            </div>
                            <div className="absolute -bottom-6 left-6 rounded-2xl border border-slate-100 bg-white px-6 py-5 shadow-xl">
                                <p className="font-display text-sm font-bold text-[#0F172A]">
                                    Value-Add Renovations
                                </p>
                                <p className="mt-1 text-xs text-slate-500">
                                    Rents. Resident experience. Asset value.
                                </p>
                            </div>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-7">
                        <Reveal>
                            <Eyebrow dark>About Value Add Management</Eyebrow>
                            <h2 className="mt-6 font-display text-3xl font-extrabold leading-[1.15] tracking-tight text-[#0F172A] sm:text-4xl">
                                Operate every property{" "}
                                <span className="font-serif font-medium italic text-[#1BA8E0]">
                                    as an owner
                                </span>
                                , not simply as a third-party manager.
                            </h2>
                            <p className="mt-8 text-base leading-relaxed text-slate-600 sm:text-lg">
                                Our approach combines strong on-site management with active
                                oversight, measurable KPIs, disciplined systems, and rapid
                                execution.
                            </p>
                            <p className="mt-5 text-base leading-relaxed text-slate-600 sm:text-lg">
                                We specialize in properties where active management can create
                                significant value through better operations, improved leasing,
                                stronger collections, controlled expenses, renovations, and property
                                stabilization.
                            </p>
                        </Reveal>
                    </div>
                </div>

                <div
                    id="markets"
                    data-testid="markets-section"
                    className="mt-28 rounded-[2rem] bg-[#0A1224] p-8 sm:p-12 lg:p-16"
                >
                    <Reveal className="flex flex-wrap items-end justify-between gap-6">
                        <div>
                            <Eyebrow>Markets</Eyebrow>
                            <h3 className="mt-4 font-display text-2xl font-extrabold tracking-tight text-white sm:text-3xl">
                                High-growth Sunbelt markets.
                            </h3>
                        </div>
                        <p className="max-w-sm text-sm leading-relaxed text-slate-400">
                            Multifamily communities throughout the Sunbelt, including opportunities
                            across:
                        </p>
                    </Reveal>
                    <div className="mt-10 grid grid-cols-1 gap-px overflow-hidden rounded-2xl bg-white/10 sm:grid-cols-2 lg:grid-cols-5">
                        {MARKETS.map((m, i) => (
                            <div
                                key={m}
                                data-testid={`market-${i + 1}`}
                                className="group bg-[#0A1224] p-6 transition-colors duration-500 hover:bg-[#111D36]"
                            >
                                <MapPin
                                    size={18}
                                    className="text-[#1BA8E0] transition-transform duration-500 group-hover:-translate-y-1"
                                />
                                <p className="mt-4 font-display text-base font-bold text-white">{m}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
